import { OnInit, ElementRef } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
var AdvancedTableHeaderComponent = /** @class */ (function () {
    function AdvancedTableHeaderComponent(elementRef, summaryService, contextMenuService) {
        var _this = this;
        this.summaryService = summaryService;
        this.contextMenuService = contextMenuService;
        this.searchTextChanged = new Subject();
        this.elementRef = elementRef;
        this.summaryService.sortChanged$.subscribe(function (result) {
            if (result) {
                if (_this.params) {
                    var colDef = _this.params.column.getColDef();
                    var currentColDef = result.column.getColDef();
                    if (colDef && currentColDef) {
                        if (colDef.field != currentColDef.field) {
                            _this.sorted = '';
                            _this.params.column.setSort(null);
                        }
                    }
                }
            }
        });
    }
    AdvancedTableHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchTextChanged.pipe(debounceTime(500), distinctUntilChanged(), tap(function (value) {
            // this.isPropertyLoading = true
        })).subscribe(function (result) {
            _this.summaryService.setFilter(_this.params);
        });
    };
    AdvancedTableHeaderComponent.prototype.agInit = function (params) {
        this.params = params;
        if (this.params.column.getSort()) {
            if (this.params.column.isSortAscending()) {
                this.sorted = 'asc';
            }
            else if (this.params.column.isSortDescending()) {
                this.sorted = 'desc';
            }
            else {
                this.sorted = '';
            }
        }
    };
    AdvancedTableHeaderComponent.prototype.onMenuClick = function () {
        this.params.showColumnMenu(this.querySelector('.customHeaderMenuButton'));
    };
    AdvancedTableHeaderComponent.prototype.onSortRequested = function (order, event) {
        if (this.params.column.getSort()) {
            this.handleSorting();
        }
        else {
            this.sorted = "asc";
        }
        this.params.column.setSort(this.sorted, event.shiftKey);
        //its time
        this.summaryService.setSort(this.params);
    };
    ;
    AdvancedTableHeaderComponent.prototype.handleSorting = function () {
        if (this.params.column.isSortAscending()) {
            this.sorted = 'desc';
        }
        else if (this.params.column.isSortDescending()) {
            this.sorted = 'asc';
        }
        else {
            this.sorted = '';
        }
    };
    ;
    AdvancedTableHeaderComponent.prototype.onContextMenu = function ($event) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: ''
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    AdvancedTableHeaderComponent.prototype.onCloseContextMenu = function () {
        //console.log('close menu')
    };
    AdvancedTableHeaderComponent.prototype.input = function (keyword) {
        this.searchTextChanged.next(keyword);
    };
    AdvancedTableHeaderComponent.prototype.querySelector = function (selector) {
        return this.elementRef.nativeElement.querySelector('.customHeaderMenuButton', selector);
    };
    return AdvancedTableHeaderComponent;
}());
export { AdvancedTableHeaderComponent };
